import { render, staticRenderFns } from "./Elective.vue?vue&type=template&id=537cd516&scoped=true&"
import script from "./Elective.vue?vue&type=script&lang=js&"
export * from "./Elective.vue?vue&type=script&lang=js&"
import style0 from "./Elective.vue?vue&type=style&index=0&id=537cd516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cd516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537cd516')) {
      api.createRecord('537cd516', component.options)
    } else {
      api.reload('537cd516', component.options)
    }
    module.hot.accept("./Elective.vue?vue&type=template&id=537cd516&scoped=true&", function () {
      api.rerender('537cd516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CourseRequestForms/Elective.vue"
export default component.exports